
import { Grid, Typography, Box, Tooltip } from '@mui/material'
import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "10",
    "ComponentType": "STANDARD DONUT COLOR",
    "Visible": "1",
    "Label": "",
    "HelpText": "TBD",
    "Values": [
        {
            "Order": "10",
            "SegmentLabel1": "0",
            "SegmentLabel2": "0",
            "Color": "#209D70"
        },
        {
            "Order": "20",
            "SegmentLabel1": "0",
            "SegmentLabel2": "0",
            "Color": "#FEC957"
        },
        {
            "Order": "30",
            "SegmentLabel1": "0",
            "SegmentLabel2": "0",
            "Color": "#E6323A"
        }
    ]
}
*/


const DonutChart = (props) => {

    const colors = props.component.Values.map((x)=>{return x.Color})
    const values = props.component.Values.map((x)=>{return x.Distribution}) //parseInt(x.SegmentLabel2,0)})
    //const labels = props.component.Values.map((x)=>{return parseInt(x.SegmentLabel1,0)+"%"})
    const data ={
        datasets:[
            {

                label: [props.component.Label],
                data: values,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 0,
            }
        ]
    }

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
          opacity: 1, x: 0, y: 0,
          transition: {
            delay: 0.1,
            duration: 0.5,
          }
        }
      }
    const options = {
        responsive: true,
        cutout: '80%',
        animation:{
            animateRotate: true,
            render: false,
        },
        tooltips:{
            enabled: true
        },
        plugins: {
            legend: {
                display: false
            },
            // labelCenter: {
            //     labels: [
            //       {
            //         text: props.CurrentOWSValue,
            //         font: {
            //           size: 3.25,
            //           unit: "rem",
            //           color: 'black',
            //           style: "bold"
            //         }
            //       }
            //     ]
            //   }
            
        }
    }
    return (
        <Grid lg={4} md={4} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
          <motion.div variants={motionVariants} initial="hidden" animate="show" whileHover={{scale:1.1}} style={{ height: '100%'}}>

          
                <Grid
                    container
                    direction="row"
                    alignItems="top"
                    justifyContent="center"

                >
                    <Grid item xs={8} >
                        <Box sx={{ maxWidth: "200px" }}>
                             <Doughnut data={data} options={options}/>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Tooltip title={props.component.HelpText}>
                            <Typography variant="body2" fontWeight="bold" align="center">{props.component.Label}</Typography>
                        </Tooltip>
                    </Grid>
                </Grid>
                </motion.div>
        </Grid>

    )
}

export default DonutChart;